import type { DepositClabesTranslations } from "../interfaces/depositClabes";

export const depositClabesTranslations: DepositClabesTranslations = {
  // Page
  page_title: "CLABEs de depósito",
  page_subtitle: "Contas recebedoras para depósitos SPEI (México)",
  why_banner:
    "Sem uma CLABE registrada, os depósitos SPEI da organização não podem ser atribuídos nem creditados.",
  no_org_prompt: "Selecione uma organização para ver suas CLABEs.",

  // Org selector
  org_label: "Organização",
  org_placeholder: "Buscar organização…",
  org_loading: "Carregando organizações…",
  org_empty: "Nenhuma organização encontrada.",
  org_error: "Não foi possível carregar as organizações.",
  org_truncated: "Há mais organizações do que as exibidas; refine a busca pelo nome.",

  // List
  list_title: "CLABEs registradas",
  filter_placeholder: "Filtrar por CLABE ou nota…",
  filter_no_results: "Nenhuma CLABE corresponde ao filtro.",
  empty_title: "Sem CLABEs registradas",
  empty_description:
    "Registre a primeira conta recebedora para habilitar os depósitos SPEI desta organização.",
  error_load: "Não foi possível carregar as CLABEs da organização.",
  error_retry: "Tentar novamente",
  registered_at: "Registrada em",
  note_label: "Nota",
  status_active: "Ativa",
  status_inactive: "Inativa",
  flavor_static: "Estática",
  flavor_dynamic: "Dinâmica",
  copy_aria: "Copiar",
  copy_success: "Copiado para a área de transferência",

  // Register dialog
  button_register: "Registrar CLABE",
  dialog_title: "Registrar CLABE de depósito",
  dialog_description: "A conta recebedora ficará vinculada à organização selecionada.",
  dialog_org_label: "Organização",
  dialog_account_label: "CLABE",
  dialog_account_placeholder: "6461 8011 1122 2233 33",
  dialog_account_helper: "18 dígitos, sem espaços ou hífens.",
  dialog_note_label: "Nota (opcional)",
  dialog_note_placeholder: "ex.: CLABE recebedora principal",
  dialog_cancel: "Cancelar",
  dialog_submit: "Registrar",
  validation_account: "A CLABE deve ter exatamente 18 dígitos.",
  hint_already_registered: "Esta CLABE já está registrada para esta organização.",
  toast_registered: "CLABE registrada",
  toast_already_registered: "Esta CLABE já estava registrada para a organização",
  error_cross_org:
    "Esta CLABE já está atribuída a outra organização. Uma CLABE só pode estar ativa em uma organização por vez.",
  error_no_write_permission: "Você não tem permissão para registrar CLABEs de depósito.",
  error_register: "Não foi possível registrar a CLABE.",

  // Detail drawer
  drawer_title: "Detalhe da CLABE",
  drawer_section_details: "Detalhes",
  drawer_section_metadata: "Metadados",
  drawer_id: "ID",
  drawer_reference: "Referência",
  drawer_created: "Registrada",
  drawer_updated: "Atualizada",
};
